/**
 * Created by qiushaoyu on 2017/12/6.
 */
import axios from 'axios'
import config from './config'
import i18n from '../locale/i18n'
import { getAuthorization, getBossToken, setAuthorization } from './userInfo'
import { getQueryVariable } from '@/util/const'

let lang = getQueryVariable('lang') || window.localStorage.getItem('lang')

let a = getAuthorization()
let b = getBossToken()

axios.defaults.headers.common['Accept-Language'] = i18n.locale
a && (axios.defaults.headers.common['Authorization'] = a)
b && (axios.defaults.headers.common['BossToken'] = b)
axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'

export default {
    /**
     * axios Post请求
     * @param api  服务器API
     * @param params  对象参数
     * @param timeout  请求超时时间
     * @returns {Promise}
     * @constructor
     */
    post(api, params = {}, timeout) {
        return new Promise((resolve, reject) => {
            if (timeout) {
                config.timeout = timeout;
            }
            params.lang = getLang(lang);
            axios.post(api, {body: {...params}}, config)
                .then(res => {
                  resolve(res);
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    /**
     * axios  Get请求
     * @param api  服务器api
     * @param params  路径参数
     * @returns {Promise}
     * @constructor
     */
    get(api, params = {}) {
        config.params=params
        return new Promise((resolve, reject) => {
            axios.get(api, config)
                .then(res => {
                  config.params={}
                    resolve(res);
                })
                .catch(err => {
                  config.params={}
                    reject(err);
                })

        })
    }
}

function getLang (lang) {
  if (lang === 'tc') {
    return 'zh-TW'
  }
  if (lang === 'sc') {
    return 'zh-CN'
  }
  if (lang === 'en') {
    return 'en-US'
  }
}





// WEBPACK FOOTER //
// ./src/axios/index.js